import { Card } from "@/Components/ui/card"
import { useContext } from "react";
import { AppContext } from "@/App";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import { useIsMobile } from "@/hooks/use-mobile";
import UpcomingDeliverablesTable from "@/Components/UpcomingDeliverables_table/UpcomingDeliverablesTable";

export type UpcomingDeliverableColumnVisibility = {
    id: boolean
    workstream: boolean
    workPackage: boolean
    deliverable: boolean
    actualFinish: boolean
    status: boolean
    plannedFinish: boolean
    owner: boolean
}

interface UpcomingDeliverablesProps {
  visibility?: UpcomingDeliverableColumnVisibility
}

function UpcomingDeliverables({ visibility }: UpcomingDeliverablesProps) {
  const app = useContext(AppContext);
  const isMobile = useIsMobile();
  const zoomLevel = useResponsiveZoom();

  function loadColumnVisibility() : UpcomingDeliverableColumnVisibility {
    if (visibility) {
      return visibility;
    }
    const localStorageValue = localStorage.getItem(app.applicationUser?.id + "_Upcoming Deliverables_columnVisibility");
    if (localStorageValue) {
      const visibiltyValues: { columnId: string, isVisible: boolean }[] = JSON.parse(localStorageValue);
      return ({
        id: visibiltyValues.find((v) => v.columnId === "id")?.isVisible ?? false,
        workstream: visibiltyValues.find((v) => v.columnId === "workstream")?.isVisible ?? false,
        workPackage: visibiltyValues.find((v) => v.columnId === "workPackage")?.isVisible ?? true,
        deliverable: visibiltyValues.find((v) => v.columnId === "deliverable")?.isVisible ?? true,
        actualFinish: visibiltyValues.find((v) => v.columnId === "actualFinish")?.isVisible ?? true,
        status: visibiltyValues.find((v) => v.columnId === "status")?.isVisible ?? true,
        plannedFinish: visibiltyValues.find((v) => v.columnId === "plannedFinish")?.isVisible ?? true,
        owner: visibiltyValues.find((v) => v.columnId === "owner")?.isVisible ?? true,
    })
  }
    return {
      id: false,
      workstream: false,
      workPackage: true,
      deliverable: true,
      actualFinish: true,
      status: true,
      plannedFinish: true,
      owner: true,
    }
  }

  return (
    <Card className={`${isMobile ? "mb-8" : "p-2 "} flex flex-col items-center border-none shadow-none`} style={{ zoom: zoomLevel }}>
        <div className={`text-center w-full ${isMobile ? "text-4xl rounded-t-lg bg-table-header mx-2 p-2" : "text-3xl"}`}>Deliverables</div>
          <UpcomingDeliverablesTable
              visibility={loadColumnVisibility()}
          />
    </Card>
  )
}

export default UpcomingDeliverables